<div class="landing_root">
  <div class="banner">
    <div class="banner-title">Find My Bus</div>
    <a href="https://www.snapper.co.nz" title="Snapper Website">
      @if (desktopSize()) {
        <img class="snapper-icon" src="/assets/img/Snapper_FISH_White.png" width="46" height="28" alt="Snapper logo" />
      } @else {
        <img class="mobile-snapper-icon" src="/assets/img/Snapper_FISH_White.png" alt="Snapper logo" />
      }
    </a>
  </div>

  <div class="content-wrapper">
    <vehicle-state />
  </div>
</div>
